import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { ButtonIcon } from 'shared/components/Button';

export const GoalEditButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <ButtonIcon
      aria-label="edit goal"
      onClick={onClick}
      size="md"
      variant="outline"
    >
      <Icon
        name={iconNames.pen}
        width="16px"
        height="18px"
        fill="var(--fgPrimary)"
      />
    </ButtonIcon>
  );
};
